import React, { useEffect, useState } from 'react';
import Icon from './Icon.js';
import axios from 'axios';
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
    Tooltip
} from "@material-tailwind/react";
import {
    UserIcon,
    MapPinIcon,
    TruckIcon
} from "@heroicons/react/24/solid";


const ListingCard = ({icon, tags, username, id, location, description, isListingClaimed, image, onClick }) => {
  const [isClaimed, setIsClaimed] = useState(isListingClaimed)
  const [isIconClicked, setIsIconClicked] = useState(isListingClaimed);
  
  let coordinates = `${location.lat}, ${location.lng}`

  const tagList = tags.map((tag, index) => (
    <div key={index} className="inline-block bg-grey-400 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2">
      #{tag.toLowerCase()}
    </div>
  ));

  const getIsClaimed = async (id) => {
    try {
      const res = await axios.put(
        `https://curb-it-backend-91f194a5e08f.herokuapp.com/listing/is-claimed/${id}`
      );
      setIsClaimed(res.data.isClaimed);
    } catch (err) {
      console.log(err);
    }
  };

  const handleIconClick = () => {
    setIsIconClicked((prevState) => !prevState);
    getIsClaimed(id);
  };
  
  return (
    <Card onClick={onClick} className="bg-silver w-full max-w-[26rem] shadow-lg mb-6">
        <CardHeader floated={false} color="blue-gray">
            {image ? (
                <img src={image} alt="Uploaded Image" />
                ) : (
                    <div>
                    <img src="/images/placeholder-image.png" alt="Image not available" />
                    <span className="absolute inset-0 flex items-center justify-center text-midnight text-lg max-w-xs text-center">
                      Ups, looks like {username} didn't upload any photo
                    </span>
                    </div>
            )}
          <div className="to-bg-black-10 absolute inset-0 h-full w-full bg-gradient-to-tr from-transparent via-transparent to-black/60 " />
          <Tooltip onClick={handleIconClick} content={`${
            !isIconClicked
              ? 'Claim It!'
              : 'Unclaim It!'
            }`} placement="bottom">
          <Button
          size="sm"
          color="red"
          variant="text"
          className="!absolute top-2 right-2 rounded-full p-0"
          ripple="light"
        >
          
        <Icon name={icon} onClick={handleIconClick} isClaimed={isIconClicked} />
         
        </Button>
        </Tooltip>
        </CardHeader>
        <CardBody>
          <div className="mb-3 flex items-center justify-between">
            <Typography variant="h5" color="blue-gray" className="font-medium">
              
            </Typography>
            <Typography
              color="blue-gray"
              className="flex items-center gap-1.5 font-normal"
            >
              <UserIcon className="-mt-0.5 h-5 w-5 text-grey-400" />
              {username}
            </Typography>
          </div>
          <Typography font="orbit" color="gray" class="italic">"{description}"
          </Typography>
          <div className="group mt-8 inline-flex flex-wrap items-center gap-3">
            <Tooltip content="Open Google Maps">
              <a href={`https://www.google.com/maps/dir//${coordinates}`} className="cursor-pointer rounded-full border border-blue-500/5 bg-blue-500/5 p-3 text-blue-500 transition-colors hover:border-blue-500/10 hover:bg-blue-500/10 hover:!opacity-100 group-hover:opacity-70">
                <MapPinIcon className="h-5 w-5" />
              </a>
            </Tooltip>
            <Tooltip content="Uber back home">
              <a href={`https://m.uber.com/ul/?action=setPickup&dropoff[latitude]=${location.lat}&dropoff[longitude]=${location.lng}`} className="cursor-pointer rounded-full border border-blue-500/5 bg-blue-500/5 p-3 text-blue-500 transition-colors hover:border-blue-500/10 hover:bg-blue-500/10 hover:!opacity-100 group-hover:opacity-70">
                <TruckIcon className="h-5 w-5" />
              </a>
            </Tooltip>
          </div>
        </CardBody>
        <CardFooter className="pt-3">
       

          <div className="flex flex-wrap mt-0">{tagList}</div>
        </CardFooter>
      </Card>
//     <div onClick={onClick} className="bg-amber-600 rounded-lg p-4 mb-4

//      relative">
//       <div className="relative">
//         <div
//           onClick={handleIconClick}
//           className={`absolute cursor-pointer ${
//             isIconClicked
//               ? 'border-4 border-red rounded-full'
//               : 'border-4 border-tahiti-500 rounded-full'
//           }`}
//           style={{
//             width: '50%',
//             top: '0',
//             left: '0',
//             transform: 'translate(-50%, -50%)',
//           }}
//         >
//           <Icon name={icon} />
//           {isIconClicked && (
//             <span className="absolute inset-0 flex items-center justify-center text-red text-xs">
//               CLAIMED
//             </span>
//           )}
//         </div>
//         <img src={image} alt="Image" className="w-full h-full rounded-lg" />
//       </div>
//       <div className="text-silver bg-black py-2 px-4 mt-4 rounded-lg">
//         <div className="text-white text-lg">{description}</div>
//       </div>
//       <div className="flex items-center justify-between mt-4">
//         <div className="text-silver">{username}</div>
//         <a
//           href={`https://m.uber.com/ul/?action=setPickup&dropoff[latitude]=${location.lat}&dropoff[longitude]=${location.lng}`}
//         >
//           <i className="fa-brands fa-uber"></i>
//         </a>
//       </div>
//       <a
//         href={`https://www.google.com/maps/dir//${coordinates}`}
//         className="block text-white mt-2"
//       >
//         📍 Take me there
//       </a>
//     </div>
  );

};

export default ListingCard;
  
